// extracted by css-extract-rspack-plugin
export default {"customFunctionExprValue":"customFunctionExprValue-WsZ6k4"};